















import { defineComponent, computed, inject } from "@vue/composition-api";
import { SessionContext } from "../ts/SessionContext";

export default defineComponent({
	setup(){

		const getSessionContext = inject<() => SessionContext>("getSessionContext");

		if(!getSessionContext){
			throw Error("Session Progress Bar: Session context missing!")
		}

		const {
			progressStepIndex,
			progressStepCount,
		} = getSessionContext();

		const steps = computed(() => {
			const steps:any = [];
			for(let i = 0; i < progressStepCount.value; i++){
				steps.push(i <= progressStepIndex.value);
			}
			return steps;
		});

		return {
			steps,
		};
	}
});

